var _rect, _path, _path2, _circle, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullscreenHintergrundfarbe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 99.5C168 124.905 185.405 125 160 125C134.595 125 114 104.405 114 79C114 53.5949 134.595 33 160 33C185.405 33 168 74.0949 168 99.5Z",
    fill: "#D2D7DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 79C181.5 53.595 145.095 49 170.5 49C195.905 49 206.817 53.595 206.817 79C206.817 104.405 195.905 121 170.5 121C168 101 181.5 104.405 181.5 79Z",
    fill: "#A5B0B7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 79,
    r: 30,
    fill: "#F1F2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.881 97.1777C145.107 97.1777 144.379 96.8802 143.83 96.3375L141.844 94.3494C140.721 93.2156 140.719 91.3743 141.838 90.2425L144.452 87.6212L144.982 83.9546C145.284 81.8479 146.279 79.8578 147.786 78.3501L157.614 68.5202L154.72 65.6255C154.434 65.3421 154.277 64.9621 154.277 64.5601C154.277 64.158 154.434 63.7781 154.72 63.4947C155.003 63.2092 155.383 63.0524 155.785 63.0524C156.187 63.0524 156.567 63.2092 156.851 63.4947L159.745 66.3894L162.638 63.4947C164.25 61.8865 166.387 61 168.66 61C170.934 61 173.073 61.8865 174.681 63.4947C178 66.8135 178 72.215 174.681 75.5358L171.786 78.4285L174.681 81.3252C174.967 81.6087 175.123 81.9886 175.123 82.3906C175.123 82.7927 174.967 83.1726 174.681 83.4561C174.396 83.7395 174.018 83.8983 173.616 83.8983C173.214 83.8983 172.834 83.7415 172.55 83.4561L169.654 80.5593L159.818 90.3832C158.312 91.8889 156.322 92.8859 154.211 93.1875L150.548 93.7162L147.937 96.3314C147.386 96.8782 146.657 97.1777 145.881 97.1777ZM145.881 94.1242L148.769 91.2295C148.999 91.0004 149.3 90.8476 149.622 90.8034L153.781 90.2003C155.25 89.9892 156.637 89.2977 157.685 88.2484L167.521 78.4265L159.749 70.655L149.921 80.485C148.872 81.5343 148.178 82.9193 147.969 84.3868L147.366 88.5499C147.32 88.8695 147.169 89.1711 146.942 89.3982L144.054 92.2949L145.881 94.1242ZM169.654 76.2957L172.55 73.403C174.693 71.2601 174.693 67.7704 172.55 65.6275C171.513 64.5902 170.132 64.0193 168.662 64.0193C167.191 64.0193 165.81 64.5902 164.775 65.6275L161.882 68.5222L169.654 76.2957Z",
    fill: "#4C6170"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.825 87.8579C151.423 87.8579 151.043 87.7011 150.76 87.4157C150.173 86.8287 150.173 85.8718 150.76 85.2828L159.675 76.3675C159.961 76.0821 160.339 75.9253 160.741 75.9253C161.143 75.9253 161.523 76.0821 161.806 76.3675C162.092 76.651 162.248 77.0309 162.248 77.433C162.248 77.835 162.092 78.2149 161.806 78.4984L152.891 87.4136C152.607 87.7011 152.228 87.8579 151.825 87.8579Z",
    fill: "#4C6170"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 129C132.205 129 110 106.795 110 79.5C110 61.7006 119.653 45.1924 135.204 36.3979C135.286 36.336 135.361 36.2824 135.443 36.2329C135.567 36.1586 135.699 36.0926 135.835 36.039C143.062 32.0872 151.242 30 159.5 30C174.738 30 188.899 36.8929 198.378 48.9131C198.506 49.0328 198.617 49.1606 198.72 49.2926C198.795 49.3958 198.865 49.4989 198.923 49.6103C205.514 58.281 209 68.6141 209 79.5C209 101.371 194.34 120.894 173.331 127.02C173.187 127.082 173.034 127.131 172.877 127.173C172.824 127.185 172.741 127.201 172.663 127.214C168.361 128.398 163.934 129 159.5 129ZM135.975 43.1546C123.732 51.1159 116.188 64.8975 116.188 79.5C116.188 103.384 135.616 122.812 159.5 122.812C162.47 122.812 165.444 122.503 168.365 121.893L166.133 112.97C163.967 113.395 161.769 113.61 159.578 113.61C140.814 113.61 125.547 98.343 125.547 79.5784C125.547 68.2181 131.359 57.489 140.81 51.2066L135.975 43.1546ZM174.317 120.193C191.432 113.964 202.812 97.815 202.812 79.5C202.812 70.9118 200.305 62.6576 195.548 55.5338L188.132 61.0984C191.72 66.6176 193.61 72.9743 193.61 79.5784C193.61 93.5621 185.013 106.106 172.073 111.225L174.317 120.193ZM159.578 51.7346C144.225 51.7346 131.735 64.2251 131.735 79.5784C131.735 94.9316 144.225 107.422 159.578 107.422C174.932 107.422 187.422 94.9316 187.422 79.5784C187.422 64.2251 174.932 51.7346 159.578 51.7346Z",
    fill: "#4C6170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#4C6170"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 23,
    width: 24,
    height: 8.28319,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 23,
    width: 24.8496,
    height: 8,
    transform: "rotate(90 86 23)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 23,
    width: 24.8496,
    height: 8,
    transform: "rotate(90 238 23)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 31.2832,
    width: 24,
    height: 8.28319,
    transform: "rotate(-180 238 31.2832)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 140,
    width: 24,
    height: 8.28319,
    transform: "rotate(-180 238 140)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 140,
    width: 24.8496,
    height: 8,
    transform: "rotate(-90 230 140)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 140,
    width: 24.8496,
    height: 8,
    transform: "rotate(-90 78 140)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 131.717,
    width: 24,
    height: 8.28318,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenHintergrundfarbe);
export default __webpack_public_path__ + "static/media/fullscreen_hintergrundfarbe.6a441e1c801e7c281f59c06fea9ef7c9.svg";
export { ForwardRef as ReactComponent };